import React, { useContext, useState } from 'react';
import { Col, Row, Table } from 'reactstrap';
import moment from 'moment';

import { Filter } from 'common/Filter';
import { FILTERS } from 'pages/Customers/constant';
import NoData from 'common/NoData';
import BookingAccordionDetails from 'pages/Customers/components/CustomerDetail/components/Booking/BookingDetailsAccordion';

import logo from '../../../../../images/user.png';
import { PartnerContextDetail } from 'hooks/useBooking';

const GridFilterBar = ({
  filterCriteria,
  totalCount,
}: {
  filterCriteria: any;
  totalCount: number;
}) => {
  return (
    <Row className="mb-2 mt-2">
      <Col sm={2} md={3} className="d-flex align-items-center">
        <Filter filterCriteria={filterCriteria} />
        <span className="mx-2 record-count-results">
          {totalCount} results
        </span>
      </Col>
    </Row>
  );
};

const PartnerBookings = () => {
  const [openRow, setOpenRow] = useState<string | null>(null);
  const context = useContext(PartnerContextDetail);
  if (!context) return null;

  const { partnerBookings } = context;
  const { isLoading, error, data } = partnerBookings;


  const toggleRow = (id: string) => {
    setOpenRow((prev) => (prev === id ? null : id));
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error fetching bookings.</p>;
  if (!data.length)
    return <NoData customMessage="No Partner Bookings Available." />;

  return (
    <div>
      <h5 className="mt-2 heading">
        Bookings <span>({data.length})</span>
      </h5>

      <GridFilterBar
        filterCriteria={FILTERS}
        totalCount={data.length}
      />

      <Table bordered hover responsive size="sm" striped className="dataTable">
        <thead>
          <tr>
            <th>Date</th>
            <th>Time</th>
            <th>Occasions</th>
            <th>Person</th>
            <th>Meal</th>
            <th>Chef</th>
            <th>Address</th>
            <th>Status</th>
            <th>Review</th>
          </tr>
        </thead>

        <tbody>
          {data.map((booking: any) => (
            <React.Fragment key={booking._id}>
              <tr>
                <td>
                  <i
                    className={`bi ${
                      openRow === booking._id
                        ? 'bi-chevron-up'
                        : 'bi-chevron-down'
                    }`}
                    style={{ cursor: 'pointer', marginRight: 8 }}
                    onClick={() => toggleRow(booking._id)}
                  />
                  {moment(booking.startDate).format('DD/MM/YYYY')}
                </td>

                <td>
                  {booking.startTime} - {booking.endTime}
                </td>

                <td>{booking.requirement || 'N/A'}</td>
                <td>{booking.headCount || 'N/A'}</td>

                <td>
                  {booking.meals
                    ?.map(
                      (m: string) =>
                        m.charAt(0).toUpperCase() + m.slice(1)
                    )
                    .join(', ') || 'N/A'}
                </td>

                <td>
                  <img
                    src={booking.chef?.image || logo}
                    alt="Chef"
                    style={{
                      width: 30,
                      height: 30,
                      objectFit: 'cover',
                      marginRight: 8,
                    }}
                  />
                  {booking.chef?.firstName || 'Unassigned'}
                </td>

                <td>
                  {booking.billingAddress?.address},{' '}
                  {booking.billingAddress?.city},{' '}
                  {booking.billingAddress?.region}
                </td>

                <td>
                  <span
                    className={`circle ${
                      booking.status === 3
                        ? 'completed'
                        : booking.status === 2
                        ? 'pending'
                        : booking.status === 1
                        ? 'cancelled'
                        : ''
                    }`}
                  />
                </td>

                <td>{booking.description || 'N/A'}</td>
              </tr>

              {openRow === booking._id && (
                <BookingAccordionDetails
                  booking={booking}
                  state={true}
                  toggleState={() => toggleRow(booking._id)} index={0}                />
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default PartnerBookings;
